import request from '../../utils/request'

export async function addToIdeaMass(params, config) {
  const add = _params => request.post('/zhikuan/ins/inspiration/add-into-inspiration-new', _params, config)
  const result = await add(params)
  return result
}

export async function removeToIdeaMass(params) {
  const remove = _params => request.post('/zhikuan/ins/inspiration/remove-from-inspiration', _params)
  const result = await remove(params)
  return result
}
